import Glide from '@glidejs/glide';

// Slider principal en portada
let sliderPrincipal = new Glide('.section1__wrapper', {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    autoplay: 8000,
    hoverpause: true,
    animationTimingFunc: 'ease-in-out',
    animationDuration: 900,
    breakpoints: {
        768: {
            perView: 1,
            autoplay: false,
            swipeThreshold: false,
            dragThreshold: false,
        }
    }
}).on('run.after', () => {
    const currentIndex = sliderPrincipal.index;

    // Eliminar la clase 'active' de todos los bullets
    const bullets = document.querySelectorAll('.bullet__btn');
    bullets.forEach(bullet => bullet.classList.remove('active'));

    // Agregar la clase 'active' al bullet correspondiente
    bullets[currentIndex].classList.add('active');
});

sliderPrincipal.mount();

// Reproducir los vídeos de Youtube
document.querySelectorAll('.showVideoPortada').forEach(item => {
    item.addEventListener('click', function () {
        let videoId = this.dataset.id;
        // Ocultar todos los vídeos
        document.querySelectorAll('.video-container').forEach(video => {
            video.style.display = 'none';
            video.querySelector('iframe').src = ''; // Detener reproducción
        });
        // Mostrar el vídeo seleccionado
        const selectedVideo = document.getElementById('video-' + videoId);
        selectedVideo.style.display = 'block';
        // Configurar el src del iframe para reproducir automáticamente
        selectedVideo.querySelector('iframe').src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
    });
});

// Formulario de contacto de portada
const formContactoPortada = document.getElementById('formContactoPortada');
formContactoPortada.addEventListener('submit', function (e) {
    e.preventDefault();
    let datos = new URLSearchParams(new FormData(formContactoPortada)).toString();
    let formContactoAlert = document.getElementById('formContactoAlert');
    let formButton = document.querySelector('.section5__btn');
    let alertDimiss = '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';
    formContactoAlert.classList.remove('alert-danger', 'alert-success');
    formContactoAlert.classList.add('alert', 'alert-dismissible', 'fade', 'show', 'alert-primary', 'mt-4')
    formContactoAlert.innerHTML = '<i class="fas fa-spinner fa-pulse me-1"></i> Enviando consulta...';
    formButton.innerHTML = 'Enviando...';
    formButton.classList.add('disabled');
    formButton.setAttribute('disabled', '');
    axios({
        method: 'post',
        url: '/escuela-negocios/portada-contacto',
        data: datos
    }).then(function (response) {
        formButton.innerHTML = 'Enviar';
        formButton.classList.remove('disabled');
        formButton.removeAttribute('disabled');
        if (response.data.tipo === 'success') {
            document.getElementById('nombre').value = '';
            document.getElementById('telefono').value = '';
            document.getElementById('email').value = '';
            document.getElementById('mensaje').value = '';
            document.getElementById('condiciones_ldp').removeAttribute('checked');
            grecaptcha.reset();
            formContactoAlert.classList.remove('alert-primary', 'alert-danger');
            formContactoAlert.classList.add('alert-success');
            formContactoAlert.innerHTML = '<i class="far fa-check me-1"></i> ' + response.data.texto + alertDimiss;
        } else {
            formContactoAlert.classList.remove('alert-primary', 'alert-success');
            formContactoAlert.classList.add('alert-danger');
            formContactoAlert.innerHTML = '<i class="far fa-times me-1"></i> ' + response.data.texto + alertDimiss;
        }
    }).catch(function () {
        formButton.innerHTML = 'Enviar';
        formButton.classList.remove('disabled');
        formButton.removeAttribute('disabled');
        formContactoAlert.classList.remove('alert-primary', 'alert-success');
        formContactoAlert.classList.add('alert-danger');
        formContactoAlert.innerHTML = '<i class="far fa-times me-1"></i> Ha ocurrido un error inesperado. Por favor, vuelva a intentarlo más tarde.' + alertDimiss;
    });
});
